<template>
  <section>
    <b-row>
      <b-col sm="12"
             v-if="Frases.edicion === 'generada' && opcionGuardar"
             class="text-success text-center font-weight-bold my-2"
             style="font-size: 16px"
      >
        Estos cambios aun no han sido guardados
      </b-col>
      <b-col sm="12"
             v-if="Frases.edicion === 'editada'"
             class="text-danger text-center font-weight-bold my-2"
             style="font-size: 16px"
      >
        Al hacer uso de la opción "Reiniciar" deberá ajustar nuevamente las etiquetas
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <label> Empresas </label>
        <el-select v-model="filtro.empresa"
                   filterable
                   clearable
                   remote
                   size="small"
                   no-data-text="No hay datos que coincidan"
                   no-match-text="No hay datos que coincidan"
                   :remote-method="obtenerEmpresas"
                   @change="getFrases"
        >
          <el-option v-for="item in empresas"
                     :key="item.id"
                     :label="item.nombre"
                     :value="item.id"
          />
        </el-select>
        <span v-if="filtro.empresa === ''"
              class="text-center text-danger"
        >
          Seleccione una empresa
        </span>
      </b-col>


      <b-col md="4">
        <label>Idioma</label>
        <el-select v-model="idioma.valor"
                   size="small"
                   @change="getFrases"
                   :disabled="true"
        >
          <el-option v-for="idioma in idiomas"
                     :key="idioma"
                     :label="idioma"
                     :value="idioma"
          />
        </el-select>
      </b-col>
      <b-col md="4">
        <label>Tipo</label>
        <el-select v-model="tipo.valor"
                   size="small"
                   @change="getFrases"
        >
          <el-option v-for="tipo in tipos.tipos"
                     :key="tipo.value"
                     :label="tipo.text"
                     :value="tipo.value"
          />
        </el-select>
      </b-col>

      <b-col class="text-center" v-if="validarPermisoComponente('editar-sistemas-clasificacion-productos-nuevo-y-antiguo')">
        <hr>
        <b-button v-if="Frases.edicion === 'editada' && opcionGuardar"
                  variant="danger"
                  class="mx-2"
                  @click="reiniciaFrases"
        >
          <i class="fa fa-eraser"/>
          Reiniciar
        </b-button>

        <b-button v-if="opcionGuardar"
                  variant="primary"
                  class="mx-2"
                  @click="guardarFrases"
        >
          <i class="fa fa-save"/>
          Guardar
        </b-button>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
import Swal from 'sweetalert2';
import { validarPermisoComponente } from '../../../../plugins/acl';

export default {
  name: 'frases-sga',
  data() {
    return {
      listaEmpresas: [],
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  computed: {
    ...mapState('sga', [
      'idiomas',
      'versiones',
      'version',
      'idioma',
      'tipos',
      'tipo',
      'filtro',
      'Frases',
      'empresas'
    ]),
    ...mapState('productos', ['opcionGuardar']),
    ...mapGetters('productos', ['getParams', 'getEmpresasFil']),
  },
  mounted() {
    this.tipo.valor = this.tipos.tipos[0].value;
    this.listaEmpresas = this.empresas;
  },
  methods: {
    async reiniciaFrases() {
      Swal.fire({
        title: 'Reiniciar frases SGA',
        text: 'Esta accion eliminara cualquier edicion hecha en las frases.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Reiniciar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.reiniciarFrases();
        }
      });
    },
    ...mapActions('sga', [
      'getFrases',
      'reiniciarFrases',
      'guardarFrases',
      'obtenerEmpresas'
    ]),
    ...mapMutations('dashboard', ['load']),
    ...mapMutations('sga', [
      'cambiarIdioma',
      'cambiarVersion',
      'cambiarTipo',
      'limpiarEmpresa'
    ]),
    ...mapActions('productos', ['getEmpresaFiltro']),
  },
};
</script>

<style scoped>
.tox-notifications-container {
  display: none !important;
}

.mce-notification {
  display: none !important;
}
</style>
